import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Catalogs|Badges|Create Badge|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCertMetricsBadging,
	portal: 'SP',
};

export type SPCreateBadgeLocNames =
	| 'SPCatalogsCreateBadgeTitleSection'
	| 'SPCatalogsCreateBadgeButtonCancel'
	| 'SPCatalogsCreateBadgeButtonCreateBadge'
	| 'SPCatalogsCreateBadgeLabelType'
	| 'SPCatalogsCreateBadgeErrorTypeRequired'
	| 'SPCatalogsCreateBadgeLabelCatalogItem'
	| 'SPCatalogsCreateBadgeErrorItemNoMatch'
	| 'SPCatalogsCreateBadgeErrorItemRequired';

export const spCreateBadgeLocs: LocDefs<SPCreateBadgeLocNames> = {
	SPCatalogsCreateBadgeTitleSection: {
		defaultValue: 'Create Badge',
		description: 'Page section title for: Create Badge.',
		displayPath: `${dpRoot}Title Section`,
		displayType: 'Title',
		legacyName: 'Share.CertMetricsBadging/Catalogs.CreateBadge.Title.CreateBadge',
		...sharedProperties,
	},
	SPCatalogsCreateBadgeButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Button label for: Cancel.',
		displayPath: `${dpRoot}Button Cancel`,
		displayType: 'Button',
		legacyName: 'Share.CertMetricsBadging/Catalogs.CreateBadge.Button.Cancel',
		...sharedProperties,
	},
	SPCatalogsCreateBadgeButtonCreateBadge: {
		defaultValue: 'Create Badge',
		description: 'Button label for: Create Badge.',
		displayPath: `${dpRoot}Button Create Badge`,
		displayType: 'Button',
		legacyName: 'Share.CertMetricsBadging/Catalogs.CreateBadge.Button.CreateBadge',
		...sharedProperties,
	},
	SPCatalogsCreateBadgeLabelType: {
		defaultValue: 'Type',
		description: 'Label for: Type.',
		displayPath: `${dpRoot}Label Type`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCatalogsCreateBadgeErrorTypeRequired: {
		defaultValue: 'Type is required',
		description: 'Error message for: Type required.',
		displayPath: `${dpRoot}Error Type Required`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPCatalogsCreateBadgeLabelCatalogItem: {
		defaultValue: 'Catalog Item',
		description: 'Label for: Catalog Item.',
		displayPath: `${dpRoot}Label Catalog Item`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPCatalogsCreateBadgeErrorItemNoMatch: {
		defaultValue: 'Catalog Item must match a value from the list',
		description: 'Error message for: No match found.',
		displayPath: `${dpRoot}Error Item No Match`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPCatalogsCreateBadgeErrorItemRequired: {
		defaultValue: 'Catalog Item is required',
		description: 'Error message for: Catalog Item required.',
		displayPath: `${dpRoot}Error Item Required`,
		displayType: 'Error',
		...sharedProperties,
	},
};

export const LOC_KEYS = MapLocKeys<SPCreateBadgeLocNames>(spCreateBadgeLocs);
